
import { useState } from "react";
import  SubscriptionProgressbarComponent  from "../../components/subscription/SubscriptionProgressbarComponent";
import { staticBaseUrl} from "../../config/GlobalConfig";
import SubscriptionFormInfoComponent from "../../components/subscription/SubscriptionFormInfoComponent";
import SubscriptionFormEmailComponent from "../../components/subscription/SubscriptionFormEmailComponent";
import SubscriptionEndComponent from "../../components/subscription/SubscriptionEndComponent";
import { ISubscriptionHandleChangeStep } from "../../context/model";
import SubscriptionEndCreateAccountComponent from "../../components/subscription/SubscriptionEndCreateAccountComponent";


export default function SubscriptionFormBloc() {
    const [currentStep, setCurrentStep] = useState<number>(0);
    const [token, setToken] = useState<string>('');
    const [cacheId, setCacheId] = useState<string>('');
    const [isShowPhoneNumber, setIsShowPhoneNumber] = useState<boolean>(false);
    const [subscriptionUrl, setSubscriptionUrl] = useState<string>('');

    const handleChangeStep = (step: number, dataChangeStep: ISubscriptionHandleChangeStep) =>  {
        setCurrentStep(step);
        if (dataChangeStep.token) {
            setToken(dataChangeStep.token);
        }

        if (dataChangeStep.isShowPhoneNumber) {
            setIsShowPhoneNumber(dataChangeStep.isShowPhoneNumber);
        }

        if (dataChangeStep.subscriptionUrl) {
            setSubscriptionUrl(dataChangeStep.subscriptionUrl);
        }

        if (dataChangeStep.cacheId) {
            setCacheId(dataChangeStep.cacheId);
        }
    }

    const endStepTitle = isShowPhoneNumber ? "Création de compte" : "Accès au parcours";

    return (
        <div className="subscription-form p-lg"> 
            <div className="ta-center p-x-md hide-in-desktop">
                <img src={staticBaseUrl + "/img/mgp.svg"} alt="Logo MGP" className="subscription-logo"/>
                <p className="chapo bleu mt-xl">CONTRAT COLLECTIF PSC SANTÉ DU MINISTERE DE L'INTÉRIEUR</p>
                 <div className="ta-center m-y-lg">
                    <p className="fz-md">Le ministère de l'Intérieur a retenu la MGP comme partenaire pour la mise en place et la gestion de vos solutions de complémentaire santé.</p>
                </div>
                <h1 className="fz-md m-y-lg">Je m'identifie et j'accède à mon parcours d'affiliation.</h1>
                <span className="border-fushia"></span>
            </div>    
    

            <div className="subscription-header flex va-center hide-in-mobile">
                <SubscriptionProgressbarComponent
                    current={currentStep}
                    steps={[
                        { title: "Identification", description: "" },
                        { title: "Validation", description: "" },
                        { title: endStepTitle, description: "" },
                    ]}
                />
            </div>
            <div className="subscription-main">
                {
                    currentStep === 0 && <SubscriptionFormInfoComponent handleChangeStep={handleChangeStep}/>
                }

                {
                    currentStep === 1 && <SubscriptionFormEmailComponent handleChangeStep={handleChangeStep} token={token} isShowPhoneNumber={isShowPhoneNumber} cacheId={cacheId}/>
                }

                {
                    currentStep === 2 && !isShowPhoneNumber && <SubscriptionEndComponent subscriptionUrl={subscriptionUrl} />
                }

                {
                    currentStep === 2 && isShowPhoneNumber && <SubscriptionEndCreateAccountComponent />
                }
            </div>    
        </div>
  )
}